/* import __COLOCATED_TEMPLATE__ from './find-in-view.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */

import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    searchQuery?: string;
    showEmptyState?: boolean;
    onQueryChange: (query: string) => void;
    onClear: () => void;
    view?: 'list-view' | 'table-view';
  };
}

const FindInView = templateOnlyComponent<Signature>();
export default FindInView;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::LeftNav::ConversationList::FindInView': typeof FindInView;
    'inbox2/left-nav/conversation-list/find-in-view': typeof FindInView;
  }
}
